import { useEffect, useState } from "react";

/**
 * A list's search box, debounced: `debouncedSearch` follows `search` once
 * typing pauses for `delayMs`, so each keystroke isn't a request. Put
 * `debouncedSearch` in the list's filters; `usePage` then returns to page 1.
 */
export function useDebouncedSearch(initial = "", delayMs = 300) {
  const [search, setSearch] = useState(initial);
  const [debouncedSearch, setDebouncedSearch] = useState(initial);

  useEffect(() => {
    if (search === debouncedSearch) return;
    const id = setTimeout(() => setDebouncedSearch(search), delayMs);
    return () => clearTimeout(id);
  }, [search, debouncedSearch, delayMs]);

  return { search, setSearch, debouncedSearch };
}
